/**
 * @voltxampere/ui — ATmega2560 (Arduino Mega) variant (Sprint 47-1)
 *
 * Sprint 43-5 placeholder (digital-gate) → Sprint 47-1 mcu-execution
 * canonical engine type migration. Per-family defaults Sprint 46
 * component definition'da `family: "atmega2560"`'dan resolve edilir
 * (256 KB flash, 8 KB SRAM, 86 GPIO, 16 ADC, 15 PWM).
 *
 * Reference: Microchip ATmega2560-16AU, TQFP-100. AVR-8bit family.
 * Vcc 4.5-5.5 V, fmax 16 MHz, 256 KB Flash / 8 KB SRAM / 4 KB EEPROM,
 * 86 GPIO, 16-channel 10-bit ADC, 15 PWM, 4× UART / 1 SPI / 1 I2C.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuAtmega2560 = {
    id: "atmega2560",
    nameTr: "ATmega2560 (Arduino Mega, TQFP-100)",
    nameEn: "ATmega2560 (Arduino Mega, TQFP-100)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "ATmega2560",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "atmega2560",
        clockHz: 16e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 5,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-atmega2560.js.map